import hydraulicDataConfig from '@/api/config/hydraulicDataConfig'
import { queryKeys } from '@/constant/common'
import { FormPipe } from '@/types/hydraulic'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'
import { getApiErrorMessage } from '@/helpers'

async function createPipe(payload: FormPipe): Promise<void> {
  await hydraulicDataConfig.create(payload)
}

const useAddHydraulic = (parentId?: number) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: FormPipe) => createPipe(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.hydraulic])

      toast.success(
        !!parentId ? t('AddSubPipeSuccess') : t('AddNewPipeSuccess'),
      )
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error))
    },
  })
}

export default useAddHydraulic
